module.exports = __webpack_public_path__ + "school/img/yitiji.f79f11dc.jpg";